let testCard = {
  currentCard: "5555555555554444",
  defaultCard: "5555555555554444",
};

export default testCard;
